import styled, { css, RuleSet } from 'styled-components';
import { mediaMap, shouldForwardProp, SPACES } from '@belong/themes';
import { ResponsiveProp } from '@belong/types';

export interface IDirectionProp {
  direction?: ResponsiveProp<'row' | 'column'>;
}

const directionCss = ({ direction }: IDirectionProp): RuleSet =>
  mediaMap(
    direction,
    (dir: 'row' | 'column') => css`
      flex-direction: ${dir};
      flex-wrap: ${dir === 'row' ? 'wrap' : 'nowrap'};
      gap: ${dir === 'row' ? `${SPACES.medium}rem` : `${SPACES.xsmall}rem 0`};
    `
  );

export const ChipsetWrapper = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp<IDirectionProp>('direction')
})<Required<IDirectionProp>>`
  display: flex;
  align-items: flex-start;
  ${directionCss}
`;
